import React from "react";
import PropTypes from "prop-types";
import { HISTORIC_GUARDIAN_BOND } from "../historicGuardianConfig";
import HistoricGuardianFormBase from "./HistoricGuardianFormBase";
import GoogleAutoComplete from "./GuardianshipHistoricGoogleAutoComplete";
import LabeledCreatableSelect from "./GuardianshipHistoricLabeledCreatableSelect";
import { scrollToTop } from "../../../../features/bonds/shared/formHelpers";

export default function GuardianshipHistoricGuardianForm(props) {
  return (
    <HistoricGuardianFormBase
      bondKind={HISTORIC_GUARDIAN_BOND.guardianship}
      GoogleAutoComplete={GoogleAutoComplete}
      LabeledCreatableSelect={LabeledCreatableSelect}
      scrollToTop={scrollToTop}
      {...props}
    />
  );
}

GuardianshipHistoricGuardianForm.propTypes = {
  data: PropTypes.shape({ guardians: PropTypes.array }),
  updateData: PropTypes.func.isRequired,
  globalData: PropTypes.object.isRequired,
  errors: PropTypes.object,
};
